module.exports = __webpack_public_path__ + "static/media/icon-atendimento-2.21de3c8e.svg";